import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c(VContainer,{staticClass:"mt-10 mb-0"},[_c('h4',[_vm._v("Willkommen im Accessment Center von globalCT")]),_c('p',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.info_text))])]),(!_vm.fullyInit)?_c('Loading',{attrs:{"error-message":_vm.errorMessage}}):_vm._e(),(_vm.fullyInit)?_c('StartQuestions',{attrs:{"categories":_vm.categories,"category-names":_vm.categoryNames}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }